const parseGradeYearPair = gradeYearPair => {
    if (!gradeYearPair) {
        return {};
    }
    const gradeYear = gradeYearPair.split('_');
    const grade = gradeYear[0];
    const year = Number(gradeYear[1]);
    return { grade, year };
};

export default parseGradeYearPair;
